import { SegmentChoice } from "./segmentChoice.model";

export class BookedSegmentChoiceCollection {
  private _collection: SegmentChoice[];

  constructor(segmentChoices) {
    this._collection = [];
    if (segmentChoices != null && segmentChoices._collection != null) {
      for (let index = 0; index < segmentChoices._collection.length; index++) {
        let segmentChoice = segmentChoices._collection[index];
        const segmentChoise = new SegmentChoice({segmentChoice});
        if (segmentChoise != null) {
          this.addSegmentChoice(segmentChoice);
        }
      }
    }
  }

/**
 * The unique identifier for this ancillary
 * @return {*}
 */
addSegmentChoice (segmentChoice) {
    this.removeSegmentChoice(segmentChoice);
    this._collection.push(segmentChoice);
};

clearSeats () {
    for (let index = 0; index < this._collection.length; index++) {
        let segmentChoice = this._collection[index];
        segmentChoice.clearSeat();
    }
};

/**
 * Clears a seat for the matching segment
 * @param segmentCode
 */
clearSeat (segmentCode) {
    let segmentChoice = this.findSegmentChoice(segmentCode);
    if (segmentChoice != null) {
        segmentChoice.clearSeat();
    }
};

/**
 * Merges a booked segment choice collection into this one
 * @param bookedSegmentChoiceCollection
 */
merge (bookedSegmentChoiceCollection) {
    for (let index = 0; index < bookedSegmentChoiceCollection._collection.length; index++) {
        let segmentChoice = bookedSegmentChoiceCollection._collection[index];
        this.addSegmentChoice(segmentChoice);
    }
};

/**
 * Finds the segmentChoice in this collection
 * @param segmentChoiceToFind
 * @return SegmentChoice matching SegmentChoice by segment code, null if not found
 */
findSegmentChoice (segmentChoiceToFind:SegmentChoice) {
  return this._collection.find(x=> x.segmentCode == segmentChoiceToFind.segmentCode);
};


removeSegmentChoice (segmentChoiceToRemove: SegmentChoice) {
  this._collection = this._collection.filter(x=> x.segmentCode != segmentChoiceToRemove.segmentCode);
};

getSeatBalance () {
    let total = 0;
    for (let index = 0; index < this._collection.length; index++) {
        let segmentChoice = this._collection[index];
        total += segmentChoice.getSeatBalance();
    }
    return total;
};

isEmpty () {
    return this._collection == null || this._collection.length == 0;
};


}
